// 引入权限选择控件
// import SHPermission from '../permission'


export default {
    name: 'sh-role-edit',
    data() {
        return {
            apis: {
                byKey: 'sh/role/byKey',//根据主键获取角色信息
                save: 'sh/role/save',//保存角色信息
            },
            editObj: {},//角色编辑对象
            roleKeys: [],//角色列表
            permissionData: [],
            tempPermissionData: [], //临时权限数据，用于恢复操作业务后初始化原始数据
            menuList: [], //菜单id列表，用于新增角色参数储存
            buttonList: [] //按钮id列表，用于新增角色参数储存
        };
    },
    props: ["visible", "role", "orgId", "userKey"],
    watch: {
        role: {
            deep: true,
            handler() {
                this.initRole();
            }
        }
    },
    mounted() {
        this.initRole();
    },
    methods: {
        initRole() {
            const me = this;
            me.roleKeys = [];
            me.editObj = {};
            if (me.role) {
                for (var key in me.role) {
                    me.$set(me.editObj, key, me.role[key]);
                }
                me.roleKeys.push(me.role.id);
            }
        },
        save() {//保存权限
            const me = this, permission = me.$refs['permission-box'];
            me.$refs["roleForm"].validate(valid => {
                if (!valid) {
                    return false;
                }
                me.$post({
                    url: me.apis.save,
                    params: {
                        role: me.editObj,
                        menuKeys: permission.getMenus(),
                        btnKeys: permission.getBtns(),
                        orgKeys: me.orgId ? [me.orgId] : null,
                        userKeys: me.userKey ? [me.userKey] : null
                    }
                }).then(rsp => {
                    if (rsp.success) {
                        me.$message.success('操作成功');
                        me.$emit("callback", true, rsp.retObj);
                    }
                });
            });
        },
        cancel: function () {
            this.menuList = [];
            this.buttonList = [];
            // this.permissionData = jQuery.extend(true, [], this.tempPermissionData);
            this.$emit("callback", false);
        },
    }
};


// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/role/edit/src/edit.js